
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import RoutesComponent from "./Routes";
import { destroySessionManager, initSessionManager } from "./CommonUtils/SessionManager";
function App() {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("🚀 App Mounted");

    initSessionManager(() => {
      console.log("🚪 Forced Logout Triggered");
      sessionStorage.clear();
      navigate("/");
    });

    return () => {
      destroySessionManager();
    };
  }, [navigate]);

  return <RoutesComponent />;
}

export default App;